import { Amplify } from 'aws-amplify';
import { getConfig } from 'common/config';

const LOCALHOST_CALLBACK = 'http://localhost:3000/';

const parseRedirectUrls = (envValue) =>
  envValue
    ? envValue.split(',').map((s) => s.trim()).filter(Boolean)
    : [LOCALHOST_CALLBACK];

const redirectSignIn = parseRedirectUrls(getConfig('REACT_APP_COGNITO_REDIRECT_SIGN_IN'));
const redirectSignOut = parseRedirectUrls(getConfig('REACT_APP_COGNITO_REDIRECT_SIGN_OUT'));

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: getConfig('REACT_APP_COGNITO_USER_POOL_ID'),
      userPoolClientId: getConfig('REACT_APP_COGNITO_CLIENT_ID'),
      loginWith: {
        oauth: {
          domain: getConfig('REACT_APP_COGNITO_DOMAIN'),
          scopes: ['email', 'openid', 'phone', 'profile'],
          redirectSignIn,
          redirectSignOut,
          responseType: 'code', // Authorization code flow with PKCE
        },
      },
    },
  },
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;


